export const surveyData = {
	libraries: [
		{
			info: [
				'Take a 4-question survey about this webpage and tell us if you want to do a follow-up interview. Those who are selected and complete the interview will get a <b>$75 Amazon gift code</b>!',
				'<i><u>Completing the survey does not guarantee selection.</u></i>',
			],
		},
		{
			subject:
				'What kinds of creative assets do you need for your current creative goal(s)? Select all that apply.',
			warning: '',
			answers: [
				{
					type: 'checkbox',
					value: 'Fonts and character styles',
				},
				{
					type: 'checkbox',
					value: 'Brushes',
				},
				{
					type: 'checkbox',
					value: 'Colors and color themes',
				},
				{
					type: 'checkbox',
					value: 'Graphics (e.g. illustrations, icons, patterns, etc.)',
				},
				{
					type: 'checkbox',
					value: 'Photographs',
				},
				{
					type: 'checkbox',
					value: 'Design templates (e.g. flyer, business card, social media layouts, etc.)',
				},
				{
					type: 'checkbox',
					value: 'Video',
				},
				{
					type: 'checkbox',
					value: 'UI components',
				},
				{
					type: 'checkbox',
					value: '3D models and materials',
				},
				{
					type: 'checkbox',
					value: 'Motion graphics templates',
				},
				{
					type: 'checkbox',
					value: 'Other, please specify:',
					shortAnswer: 'Please Specify',
				},
				{
					type: 'radio',
					value: 'I don’t need any creative assets right now',
				},
			],
			shortAnswer: '',
			longAnswer: '',
		},
		{
			info: [
				'<i>When we say “creative assets”, we mean things like fonts, photographs, illustrations, etc. that you can use in your own creative work.</i>',
			],
			subject: 'What did you come to this webpage to do?',
			warning: '',
			answers: [
				{
					type: 'checkbox',
					value: 'Find creative asset(s) <u>to buy</u> and use in a specific project',
				},
				{
					type: 'checkbox',
					value: 'Find <u>free</u> creative asset(s) to use in a specific project',
				},
				{
					type: 'checkbox',
					value: 'Find <u>inspiration</u> for a specific project (e.g. making a mood board, etc.)',
				},
				{
					type: 'checkbox',
					value:
						'I’m <u>just browsing</u> creative assets and don’t have a specific project in mind (e.g. just to see what’s possible)',
				},
				{
					type: 'checkbox',
					value: 'Other, please specify:',
					shortAnswer: 'Please Specify',
				},
				{
					type: 'radio',
					value: 'I didn’t mean to end up on this page',
				},
			],
			shortAnswer: '',
			longAnswer: '',
		},
		{
			subject: 'How successful do you feel with your goal(s) for coming to this webpage?',
			warning: '',
			answers: [
				{
					type: 'radio',
					value: 'Extremely successful',
				},
				{
					type: 'radio',
					value: 'Very successful',
				},
				{
					type: 'radio',
					value: 'Moderately successful',
				},
				{
					type: 'radio',
					value: 'Slightly successful',
				},
				{
					type: 'radio',
					value: 'Not at all successful',
				},
			],
			shortAnswer: '',
			longAnswer: 'Please explain your answer to the above question',
		},
		{
			info: [
				'We would also like to follow up with some customers for a remote video interview. Those who are selected for and complete a 60-minute video call will receive a <b>$75 Amazon gift code</b>!',
				'<i><u>Completing the survey does not guarantee selection.</u></i>',
			],
			subject: 'Can we contact you to learn more about your answers to this survey?',
			warning: '',
			answers: [
				{
					type: 'radio',
					value: 'Yes, sign me up!',
					shortAnswer: 'Please provide email',
					verifyEmailId: 'true',
				},
				{
					type: 'radio',
					value: 'No, I don’t want to give any more feedback',
				},
			],
			shortAnswer: '',
			longAnswer: '',
		},
	],
};
